import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { CurrentService } from '@services/current.service';
import { CurrentRights } from '@models/current.model';
import { RightValueType } from '@models/enums';
import { filter, map } from 'rxjs';

export const guard =
    (role: keyof CurrentRights): CanActivateFn =>
    () => {
        const router = inject(Router);
        const rights$ = inject(CurrentService).rights$;

        return rights$.pipe(
            filter(Boolean),
            map((rights) => {
                if (!rights) {
                    return new RedirectCommand(router.parseUrl('/access-denied'), {
                        skipLocationChange: true,
                    });
                }
                const value = rights![role];

                if (
                    value === RightValueType.Allowed ||
                    value === RightValueType.AllowedWithCondition
                )
                    return true;

                return new RedirectCommand(router.parseUrl('/access-denied'), {
                    skipLocationChange: true,
                });
            }),
        );
    };
